import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../servics/axiosClient";

// 🔥 Async call vers tenant-management
export const fetchTenantById = createAsyncThunk(
    "tenant/fetchTenantById",
    async (tenantId, thunkAPI) => {
        try {
            // axiosClient porte déjà la base URL tenant-management (config/apiConfig).
            const response = await axiosClient.get(`/tenants/${tenantId}`);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

const tenantSlice = createSlice({
    name: "tenant",
    initialState: {
        company: null,
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTenantById.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchTenantById.fulfilled, (state, action) => {
                state.loading = false;
                state.company = action.payload;
            })
            .addCase(fetchTenantById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default tenantSlice.reducer;